var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b8a249a35dd9015c880995c011a1e57293731aa3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yunnanzhiye-pc-web"]={id:"b8a249a35dd9015c880995c011a1e57293731aa3"};
      